<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> E-Commerce Payments That Scale</div>
            <div class="banner_tips mt-40 fw-300">Modern payment infrastructure for online stores. Built for speed, simplicity, and scale in fast-paced e-commerce.</div>
         </div>
       </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Why Corelinkpay?</div>
            <div class="title_tag color1">Features built for e-commerce</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb20.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Flexible Growth Plans</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">From startups to enterprises, plans that scale with your business at every stage.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb21.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Lightning-Fast Transactions</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Process payments instantly. Funds available in minutes so you can focus on customers.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb22.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Global Reach, Local Expertise</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Connect with major banks across the UK, EU, and beyond for smooth, secure global transactions.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Our E-Commerce Advantage</div>
            <div class="title_tag color1">As a leading global payment platform and open banking provider, we empower your business with innovative solutions. Our AI-driven technology and machine-learning insights deliver:</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb23.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Smart Transaction Management</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Streamline payments with real-time analytics and fraud detection.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb24.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Open Banking Innovation</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Leverage secure data-sharing with trusted banks for faster, more reliable transactions.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb25.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Effortless Integration</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Our intuitive APIs make it simple to bring your products to market and enhance customer experiences.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>


    
 
    <div class="container page_title_bg"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color1 ">FAQs</div>            
            </div>   
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_12 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How quickly can I start processing payments?" name="1">
                            <div class="coll_item">With our streamlined onboarding and plug-and-play APIs, you can be up and running in hours.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is your platform secure?" name="2">
                           <div class="coll_item">Absolutely. We use advanced encryption and AI-powered fraud detection to protect every transaction.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I use your platform for international sales?" name="3">
                           <div class="coll_item">Yes! Our network connects with leading banks worldwide, ensuring smooth cross-border payments.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
            </div>
        </div>
      </div>
    </div>
     <div class="container"> 
      <div class="page_top mb-50" >
        <div class="page_width" >
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color1 text-l">Tools to Transform Your E-Commerce Business</div>
                        <div class="title_tag color1 text-l">Experience the power of instant payments, seamless integrations, and actionable insights. Our platform is built to simplify operations and accelerate your growth, so you can focus on what matters most—your customers.</div>
                    </div>
                </div>
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t21.png" alt="">
                  </div>
                </div>
                
              </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    data(){
        return{
         
            
            activeName:'1',
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg3.png);
}

.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.no_col_gap{
    grid-column-gap:0!important;
}
</style>